import styled from 'styled-components';
import dynamic from 'next/dynamic';

import { IArticleAudio } from 'editorial/types/ArticleAudio';

const AudioPlayer = dynamic(
  () => import('shared/components/AudioPlayer').then((mod) => mod.AudioPlayer),
  {
    ssr: false,
  },
);

interface IArticleAudioProps {
  audioAsset: IArticleAudio;
  text?: string;
}

export const ArticleAudio = ({ audioAsset, text }: IArticleAudioProps) => {
  if (!audioAsset?.url) {
    return null;
  }

  return (
    <ArticleAudio.Wrapper data-qa="article_audio">
      <AudioPlayer
        src={audioAsset.url}
        text={text}
        eventLocation="editorial"
        id={audioAsset?.uuid || audioAsset?.id}
      />
    </ArticleAudio.Wrapper>
  );
};

ArticleAudio.Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 15em auto;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    width: 500px;
  }
`;
